module.exports = __webpack_public_path__ + "static/media/4.3ea0cd96.jpeg";